"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _ModalModel3 = _interopRequireDefault(require("../../../gradifui/models/ModalModel"));

var _ActionStore2 = require("../../../higher-order/ActionStore");

var _some = _interopRequireDefault(require("lodash/some"));

var _remove = _interopRequireDefault(require("lodash/remove"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _upsert = _interopRequireDefault(require("../../../util/upsert"));

var _class, _descriptor, _class3, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _class5, _descriptor8, _descriptor9, _descriptor10, _descriptor11;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var DEFAULT_FLASH_TIMEOUT = 3000;
var DEFAULT_LOADING_SPINNER_DELAY = 100;
var LoadSpinnerModel = (_class = /*#__PURE__*/function (_ModalModel) {
  _inherits(LoadSpinnerModel, _ModalModel);

  var _super = _createSuper(LoadSpinnerModel);

  function LoadSpinnerModel() {
    var _this;

    _classCallCheck(this, LoadSpinnerModel);

    _this = _super.call(this);

    _initializerDefineProperty(_assertThisInitialized(_this), "message", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(LoadSpinnerModel, [{
    key: "open",
    value: function open(message, delay) {
      var _this2 = this;

      delay = delay || DEFAULT_LOADING_SPINNER_DELAY;
      var timeStamp = new Date().getTime();
      setTimeout(function () {
        if (_this2.timeStamp === timeStamp) {
          _this2.message = message;

          _get(_getPrototypeOf(LoadSpinnerModel.prototype), "open", _this2).call(_this2);
        }
      }, delay);
      this.timeStamp = timeStamp;
    }
  }, {
    key: "close",
    value: function close() {
      this.timeStamp = null;

      _get(_getPrototypeOf(LoadSpinnerModel.prototype), "close", this).call(this);
    }
  }]);

  return LoadSpinnerModel;
}(_ModalModel3.default), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "message", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ConfirmationModalModel = (_class3 = /*#__PURE__*/function (_ModalModel2) {
  _inherits(ConfirmationModalModel, _ModalModel2);

  var _super2 = _createSuper(ConfirmationModalModel);

  // string
  // string
  // FormModel
  // (jsonFormData) => Component
  // (onConfirmClick, confirmLabel, onCancelClick, cancelLabel) => Component
  function ConfirmationModalModel() {
    var _this3;

    _classCallCheck(this, ConfirmationModalModel);

    _this3 = _super2.call(this, "confirmationModal");

    _initializerDefineProperty(_assertThisInitialized(_this3), "message", _descriptor2, _assertThisInitialized(_this3));

    _initializerDefineProperty(_assertThisInitialized(_this3), "title", _descriptor3, _assertThisInitialized(_this3));

    _initializerDefineProperty(_assertThisInitialized(_this3), "customForm", _descriptor4, _assertThisInitialized(_this3));

    _initializerDefineProperty(_assertThisInitialized(_this3), "customRender", _descriptor5, _assertThisInitialized(_this3));

    _initializerDefineProperty(_assertThisInitialized(_this3), "renderCustomControls", _descriptor6, _assertThisInitialized(_this3));

    _initializerDefineProperty(_assertThisInitialized(_this3), "hasCallbacks", _descriptor7, _assertThisInitialized(_this3));

    _this3.confirmCallback = _noop.default;
    _this3.cancelCallback = _noop.default;
    _this3.hasCallbacks = false;
    _this3.confirmLabel = "Confirm";
    _this3.cancelLabel = "Cancel";
    _this3.shouldStayOpenAfterSubmit = false;
    return _this3;
  }

  _createClass(ConfirmationModalModel, [{
    key: "open",
    value: function open(confirmEventData) {
      this.message = confirmEventData.message;
      this.title = confirmEventData.title;
      this.customForm = confirmEventData.customForm;
      this.customRender = confirmEventData.customRender;
      this.renderCustomControls = confirmEventData.renderCustomControls;
      this.renderCustomTitle = confirmEventData.renderCustomTitle;
      this.hideCloseButton = confirmEventData.hideCloseButton;
      this.hideCancelButton = confirmEventData.hideCancelButton || false;
      this.confirmCallback = confirmEventData.confirmCallback || _noop.default;
      this.cancelCallback = confirmEventData.cancelCallback || _noop.default;
      this.modalClassName = confirmEventData.modalClassName;
      this.confirmLabel = confirmEventData.confirmLabel || "Confirm";
      this.confirmClassName = confirmEventData.confirmClassName;
      this.cancelLabel = confirmEventData.cancelLabel || "Cancel";
      this.hasCallbacks = confirmEventData.confirmCallback || confirmEventData.cancelCallback;
      this.shouldStayOpenAfterSubmit = confirmEventData.shouldStayOpenAfterSubmit;
      this.hideControls = confirmEventData.hideControls || false;

      _get(_getPrototypeOf(ConfirmationModalModel.prototype), "open", this).call(this);
    }
  }, {
    key: "confirm",
    value: function confirm() {
      if (this.customForm) {
        this.customForm.allDone();

        if (this.customForm.canSubmit) {
          // By default, we close before the callback b/c the callback might be to open a new confirm
          if (!this.shouldStayOpenAfterSubmit) {
            this.close();
          }

          this.confirmCallback();
        }
      } else {
        this.close();
        this.confirmCallback();
      }
    }
  }, {
    key: "cancel",
    value: function cancel() {
      // mimic old school browser event handlers that allow cancelling "bubbling" by explicitly returning false
      if (this.cancelCallback() !== false) {
        this.close();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.message = null;
      this.title = null;
      this.customForm = null;
      this.customRender = null;
      this.renderCustomControls = null;
      this.hideCloseButton = false;

      _get(_getPrototypeOf(ConfirmationModalModel.prototype), "close", this).call(this);
    }
  }]);

  return ConfirmationModalModel;
}(_ModalModel3.default), (_descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "message", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "title", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "customForm", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "customRender", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "renderCustomControls", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "hasCallbacks", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
var MessageStore = (_class5 = /*#__PURE__*/function (_ActionStore) {
  _inherits(MessageStore, _ActionStore);

  var _super3 = _createSuper(MessageStore);

  function MessageStore(props, dispatcher) {
    var _this4;

    _classCallCheck(this, MessageStore);

    _this4 = _super3.call(this, dispatcher);

    _initializerDefineProperty(_assertThisInitialized(_this4), "messages", _descriptor8, _assertThisInitialized(_this4));

    _initializerDefineProperty(_assertThisInitialized(_this4), "confirmationModal", _descriptor9, _assertThisInitialized(_this4));

    _initializerDefineProperty(_assertThisInitialized(_this4), "loadSpinner", _descriptor10, _assertThisInitialized(_this4));

    _initializerDefineProperty(_assertThisInitialized(_this4), "localizedMessages", _descriptor11, _assertThisInitialized(_this4));

    var flashMessage = props.session && props.session.flashMessage;
    _this4.messages = flashMessage ? [{
      id: Math.floor(new Date().getTime()),
      message: flashMessage.message,
      contentKey: flashMessage.contentKey,
      timeout: flashMessage.timeout || DEFAULT_FLASH_TIMEOUT,
      className: flashMessage.className
    }] : [];
    _this4.confirmationModal = new ConfirmationModalModel();
    _this4.loadSpinner = new LoadSpinnerModel();
    _this4.localizedMessages = _mobx.observable.map({});
    return _this4;
  }

  _createClass(MessageStore, [{
    key: "showConfirmationModal",
    value: function showConfirmationModal(e) {
      this.confirmationModal.open(e.data);
    }
  }, {
    key: "confirmConfirmationModal",
    value: function confirmConfirmationModal(e) {
      this.confirmationModal.confirm();
    }
  }, {
    key: "cancelConfirmationModal",
    value: function cancelConfirmationModal(e) {
      this.confirmationModal.cancel();
    }
  }, {
    key: "showFlashMessage",
    value: function showFlashMessage(e) {
      var currentMessages = this.messages;
      var newMessage = {
        id: e.data.messageId || Math.floor(new Date().getTime()),
        message: e.data.message,
        contentKey: e.data.contentKey,
        timeout: e.data.timeout || DEFAULT_FLASH_TIMEOUT,
        className: e.data.className,
        closeable: e.data.closeable,
        icon: e.data.icon,
        link: e.data.link,
        containerId: e.data.containerId
      };

      if ((0, _some.default)(currentMessages, function (m) {
        return m.id === e.data.messageId;
      })) {
        this.logger.notify("A flash message has duplicate id, message possibly stomped", "warning");
      }

      if (e.data.containerId) {
        if (this.localizedMessages.get(e.data.containerId)) {
          this.localizedMessages.get(e.data.containerId).push(newMessage);
        } else {
          this.localizedMessages.set(e.data.containerId, [newMessage]);
        }
      } else {
        (0, _upsert.default)(currentMessages, newMessage, function (m) {
          return m.id === newMessage.id;
        });
      }
    }
  }, {
    key: "hideFlashMessage",
    value: function hideFlashMessage(e) {
      var currentMessages = e.data.containerId && this.localizedMessages[e.data.containerId] ? this.localizedMessages[e.data.containerId] : this.messages;
      (0, _remove.default)(currentMessages, function (m) {
        return m.id === e.data.messageId;
      });
    }
  }, {
    key: "clearFlashMessages",
    value: function clearFlashMessages(e) {
      if (e.data.containerId) {
        this.localizedMessages.set(e.data.containerId, null);
      } else {
        this.messages.clear();
      }
    }
  }, {
    key: "showLoadSpinner",
    value: function showLoadSpinner(e) {
      this.loadSpinner.open(e.data.message, e.data.timeout);
    }
  }, {
    key: "hideLoadSpinner",
    value: function hideLoadSpinner(e) {
      this.loadSpinner.close();
    }
  }, {
    key: "browserNavigationWarningModalCallback",
    value: function browserNavigationWarningModalCallback(event) {
      event.preventDefault();
      event.returnValue = "Are you sure? Changes you made may not be saved.";
    }
  }, {
    key: "enableNavigationWarningModal",
    value: function enableNavigationWarningModal() {
      window.addEventListener("beforeunload", this.browserNavigationWarningModalCallback);
    }
  }, {
    key: "disableNavigationWarningModal",
    value: function disableNavigationWarningModal() {
      window.removeEventListener("beforeunload", this.browserNavigationWarningModalCallback);
    }
  }]);

  return MessageStore;
}(_ActionStore2.ActionStore), (_descriptor8 = _applyDecoratedDescriptor(_class5.prototype, "messages", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class5.prototype, "confirmationModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class5.prototype, "loadSpinner", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class5.prototype, "localizedMessages", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class5.prototype, "showConfirmationModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "showConfirmationModal"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "confirmConfirmationModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "confirmConfirmationModal"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "cancelConfirmationModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "cancelConfirmationModal"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "showFlashMessage", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "showFlashMessage"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "hideFlashMessage", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "hideFlashMessage"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "clearFlashMessages", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "clearFlashMessages"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "showLoadSpinner", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "showLoadSpinner"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "hideLoadSpinner", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "hideLoadSpinner"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "enableNavigationWarningModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "enableNavigationWarningModal"), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, "disableNavigationWarningModal", [_ActionStore2.dispatchable], Object.getOwnPropertyDescriptor(_class5.prototype, "disableNavigationWarningModal"), _class5.prototype)), _class5);
exports.default = MessageStore;